'use client';

import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import { env } from 'next-runtime-env';

interface AuthProps {
  children: React.ReactNode;
}

const Auth: React.FC<AuthProps> = ({ children }) => {
  return (
    <main className="w-full bg-[url('/assets/images/racesafe-homepage-bg.jpg')] bg-cover bg-fixed bg-center">
      <div className="w-full backdrop-brightness-50">
        <GoogleOAuthProvider
          clientId={env('NEXT_PUBLIC_GOOGLE_CLIENT_ID') ?? 'missing id'}
        >
          {children}
        </GoogleOAuthProvider>
      </div>
    </main>
  );
};

export default Auth;
